// @flow
import { VIEW } from 'pages/MyAccount/services/actions/viewActions';

import type { Action } from 'pages/MyAccount/services/actions/Action.type';

function getViewSize(width: number): string {
  if (width <= 767) return 'small';
  if (width <= 991) return 'medium';
  if (width <= 1199) return 'large';
  return 'xLarge';
}

export type ViewState = {|
  viewSize: string,
|};

export const viewInitialState = {
  viewSize: getViewSize(window.innerWidth),
};

export const viewReducer = (
  state: ViewState = viewInitialState,
  action: Action
) => {
  switch (action.type) {
    case VIEW.SET_VIEW_SIZE: {
      return {
        ...state,
        viewSize: getViewSize(action.windowWidth),
      };
    }

    default: {
      return state;
    }
  }
};
